import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-search\"><path d=\"M894.293 848.782L769.138 723.627c52.338-63.716 84.195-145.636 84.195-234.383 0-200.248-163.84-364.088-364.089-364.088s-364.088 163.84-364.088 364.088 163.84 364.09 364.088 364.09c95.574 0 182.045-36.41 245.76-97.85L860.16 880.64c9.102 9.102 22.756 9.102 31.858 0 9.102-6.827 9.102-22.756 2.275-31.858z m-405.049-40.96c-175.217 0-318.577-143.36-318.577-318.578s143.36-318.577 318.577-318.577 318.578 143.36 318.578 318.577-143.36 318.578-318.578 318.578z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/search.svg
// module id = Bx0U
// module chunks = 65